<template>
  <VcLabel v-if="label" :required="isRequired" class="mb-5 font-normal">
    {{ label }}
  </VcLabel>

  <div class="w-1/2">
    <VueDatePicker
      :disabled="isDisabled"
      :model-value="modelValue ? formattedValue : ''"
      :disabled-week-days="[0, 6]"
      :min-date="minimalDate"
      :required="isRequired"
      :enable-time-picker="false"
      :model-type="format"
      :format="format"
      :clearable="false"
      no-today
      auto-apply
      @update:model-value="handleDate"
    />
  </div>

  <div v-if="errorMessage" class="text-xs text-[color:var(--color-danger)]">
    {{ errorMessage }}
  </div>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-unused-vars */
import VueDatePicker from "@vuepic/vue-datepicker";
import moment from "moment";
import { computed } from "vue";
import "@vuepic/vue-datepicker/dist/main.css";

const emit = defineEmits<{
  (e: "update:modelValue", value: Date | undefined): void;
  (e: "change", value: Date | undefined): void;
}>();

const props = withDefaults(defineProps<IProps>(), {
  isRequired: false,
  isDisabled: false,
});

interface IProps {
  label?: string | undefined;
  minimalDate: Date;
  defaultDate?: Date | undefined;
  isRequired?: boolean;
  isDisabled?: boolean;
  modelValue?: Date | undefined;
  errorMessage?: string | undefined;
}

const format = "dd-MM-yyyy";
const formattedValue = computed(() => moment(props.modelValue).format("DD-MM-YYYY"));

function handleDate(selectedDate: string) {
  const dateValue = selectedDate ? moment(selectedDate, "DD/MM/YYYY").toDate() : undefined;
  emit("update:modelValue", dateValue);
  emit("change", dateValue);
}
</script>

<style>
.dp__cell_inner.dp__cell_offset.dp__pointer.dp--future.dp__date_hover {
  color: #000 !important;
}
</style>
